import { render, staticRenderFns } from "./FeedingDetail.vue?vue&type=template&id=98505852&"
import script from "./FeedingDetail.vue?vue&type=script&lang=js&"
export * from "./FeedingDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedingDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports